<div [hidden]="!includeLabel">
    <label for="{{name}}">{{getLabelName()}}</label>
</div>
<div *ngIf="detailMode; then showSpan else showSelect"></div>
<ng-template #showSelect>
    <select #field class="form-control" [id]="(id === null ? name : id)" [name]="name" [disabled]="readOnly"
        (input)="changeValue($event, false, isNumber)">
        <option *ngIf="this.includeSelectItem" [value]="null" [selected]="value == null">{{customLabelSelect}}</option>
        <ng-container *ngIf="items && items.length > 0">
            <option *ngFor="let item of items" [value]="item.id" [selected]="item.id == value">{{ item.nome }}
            </option>
        </ng-container>
        <ng-container *ngIf="keyItems && keyItems.length > 0">
            <option *ngFor="let item of keyItems" [value]="item.key" [selected]="item.key == value">{{ item.value }}
            </option>
        </ng-container>
    </select>
</ng-template>
<ng-template #showSpan>
    <span type="text" #field [id]="(id === null ? name : id)">
        {{getComboItemText()}}
    </span>
    <hr *ngIf="includeLabel" />
</ng-template>

<div *ngIf="!detailMode">
    <app-input-feedback [hidden]="!validateRequired()" [feedbackMessage]="spanRequired"></app-input-feedback>
</div>